import type { ChartApiResponse, ChartRequestParams } from '../types';

/**
 * Данные графика из `/api/chart/widget/`.
 *
 * Запрос клиентский и одноразовый: график рисует Highcharts, который завязан
 * на DOM, — на сервере от этих данных остался бы пустой контейнер. Виджет
 * стоит внутри текста статьи, поэтому лишний запрос в SSR-рендер страницы
 * тоже ни к чему.
 *
 * `baseURL` приходит параметром, а не из `useRuntimeConfig()`: функция
 * вызывается из колбэка `IntersectionObserver`, то есть вне setup, где
 * композаблы Nuxt звать нельзя. Адрес читает модель — на этапе setup.
 *
 * Бэкенд принимает параметры вложенным `params`, но плоскими ключами:
 * `query: { params: { charts } }` ofetch сериализует в `params=[object Object]`.
 */
export async function fetchChartData(
  params: ChartRequestParams,
  baseURL: string,
): Promise<ChartApiResponse> {
  const query: Record<string, string> = {
    'params[charts]': params.charts.join(','),
  };

  if (params.period) query['params[period]'] = params.period;
  if (params.start) query['params[start]'] = params.start;
  if (params.end) query['params[end]'] = params.end;
  if (params.currency) query['params[currency]'] = params.currency;

  // Битрикс отдаёт `{ status, data, errors }` — разворачиваем, как это делает
  // `useBackendAPI` для SSR-запросов.
  const response = await $fetch<{ data?: ChartApiResponse }>('chart/widget/', {
    baseURL,
    method: 'GET',
    query,
  });

  return response?.data ?? {};
}
